import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'base_role',

  can: {
    route() {
      return this.child;
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/BaseRolePerimeter.js